// extracted by mini-css-extract-plugin
module.exports = {"Table__caption":"Table_Table__caption__Uufl4","Table__caption--dark":"Table_Table__caption--dark__ZV_9H","fadeInKeyframe":"Table_fadeInKeyframe__pZ3Pe"};